// import Vue from 'vue';
// import i18n from '@/lang/i18n';
import Vue from 'vue';
import { router } from "@/main";
import * as Sentry from '@sentry/vue';

export default {
  state: {
    authenticated: false,
    user: null,
    token: null,
    // rules: {
    //   required: (v) => (v && v !== '') || i18n.t('rules.required'),
    //   email: (v) => {
    //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     return pattern.test(v) || i18n.t('rules.email');
    //   },
    // },
  },
  mutations: {
    setАuthenticated(state, payload) {
      state.authenticated = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
  },

  actions: {
    logout({ commit }) {
      Vue.$cookies.remove('token_c');
      Vue.$cookies.remove('auth_refresh_token');
      Vue.$cookies.remove('token_e');
      Vue.$cookies.remove('active_bot');

      if (typeof Sentry !== 'undefined') {
        Sentry.configureScope((scope) => scope.setUser(null));
      }

      commit('setToken', null);
      commit('setUser', null);

      router.push({ name: 'Login' });
    },
  },

  // actions: {
  //   loadData: ({ commit, dispatch, state }, configs) => {
  //     document.title = i18n.t('login.email_field');
  //   },
  // },

  getters: {
    authenticated(state) {
      return state.authenticated;
    },
    token(state) {
      return state.token;
    },
    // user(state) {
    //   return state.user;
    // },
    // rules: (state) => {
    //   return state.rules;
    // },
  },
};
